export const parseEmailHtml = (customer, user, company, html) => {
  const info = {
    "{customerName}": customer?.firstName,
    "{customerLastName}": customer?.lastName,
    "{customerFullName}": customer?.fullName,
    "{customerAccountNumber}": customer.accountNumber,
    "{userName}": user?.firstName,
    "{userLastName}": user?.lastName,
    "{companyName}": company?.name,
  };

  for (const key of Object.keys(info)) {
    if (html?.includes(key)) {
      html = html.replace(new RegExp(key, "g"), info[key] || "");
    }
  }

  return html;
};

export function convertSeconds(totalSeconds) {
  // Calculate the number of hours
  const hours = Math.floor(totalSeconds / 3600);
  // Calculate the remaining seconds after extracting hours
  const remainingSecondsAfterHours = totalSeconds % 3600;
  // Calculate the number of minutes from the remaining seconds
  const minutes = Math.floor(remainingSecondsAfterHours / 60);
  // Calculate the remaining seconds after extracting minutes
  const seconds = remainingSecondsAfterHours % 60;

  return `${hours > 1 ? hours + " hours - " : ""} ${
    minutes > 1 ? minutes + " minutes - " : ""
  } ${seconds} seconds`;
}

export const isValidCardNumber = (number) => {
  const clean = number.replace(/\D/g, "");
  let sum = 0;
  let shouldDouble = false;

  for (let i = clean.length - 1; i >= 0; i--) {
    let digit = parseInt(clean[i], 10);

    if (shouldDouble) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }

    sum += digit;
    shouldDouble = !shouldDouble;
  }

  return clean.length >= 13 && sum % 10 === 0;
};

export const getCardType = (number) => {
  const n = number.replace(/\D/g, "");

  if (/^4/.test(n)) return "VISA";
  if (/^5[1-5]/.test(n)) return "MASTERCARD";
  if (/^3[47]/.test(n)) return "AMEX";
  if (/^6(?:011|5)/.test(n)) return "DISCOVER";

  return "UNKNOWN";
};

export const maskCardNumber = (number) => {
  const clean = number.replace(/\D/g, "");
  if (clean.length < 10) return clean;

  const first6 = clean.slice(0, 6);
  const last4 = clean.slice(-4);

  return `${first6}${"*".repeat(clean.length - 10)}${last4}`;
};
